import { render } from "./ContaPagarIndex.vue?vue&type=template&id=c47ec0e6&scoped=true&ts=true"
import script from "./ContaPagarIndex.vue?vue&type=script&lang=ts"
export * from "./ContaPagarIndex.vue?vue&type=script&lang=ts"

import "./ContaPagarIndex.vue?vue&type=style&index=0&id=c47ec0e6&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c47ec0e6"]])

export default __exports__